import React, { useRef, useState } from "react";

import personPlaceholderMale from "images/person-placeholder-male.png";
import personPlaceholderFemale from "images/person-placeholder-female.png";
import stars from "images/stars.png";
import arrowDown from "images/arrow-down-long.png";
import ArrowDown from "images/arrow-down-yellow.png";
import ArrowTop from "images/arrow-top-grey.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

import "./style.scss";

const Testimonials = ({ data }) => {
  const sliderRef = useRef();
  const [activeSlide, setActiveSlide] = useState(0);

  const onClickPrev = () => sliderRef.current.swiper.slidePrev();

  const onClickNext = () => sliderRef.current.swiper.slideNext();

  return (
    <div>
      <div className="container flex items-start justify-between sm:flex-col gap-8">
        <div className="w-1/2 sm:w-full sm:text-center">
          <h2 className="header">{data.title}</h2>
          <p className="mt-4 paragraph-normal text-gray-700">
            {data.description}
          </p>
          <div className="mt-4 flex flex-col">
            <div
              className={`w-9 h-9 rounded-full bg-white flex justify-center items-center cursor-pointer border-2 border-solid ${
                activeSlide === 0 ? " border-gray-400" : " border-yellow-400"
              }`}
              onClick={onClickPrev}
            >
              <img
                className={`h-full max-h-[60%] ${
                  activeSlide === 0 ? "" : "rotate-180"
                }`}
                src={activeSlide === 0 ? ArrowTop : ArrowDown}
                alt="down arrow"
              />
            </div>
            <div
              className={`w-9 h-9 rounded-full bg-white flex justify-center items-center mt-2 cursor-pointer border-2 border-solid ${
                activeSlide == data.content.length - 1
                  ? "border-gray-400"
                  : "border-yellow-400"
              } `}
              onClick={onClickNext}
            >
              <img
                className={`h-full max-h-[60%] ${
                  activeSlide === data.content.length - 1 ? "rotate-180" : ""
                }`}
                src={
                  activeSlide === data.content.length - 1 ? ArrowTop : ArrowDown
                }
                alt="down arrow"
              />
            </div>
          </div>
        </div>
        <div className="w-1/2 sm:w-full overflow-hidden">
          <Swiper
            slidesPerView={1}
            direction="vertical"
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            onSlideChange={({ activeIndex }) => {
              setActiveSlide(activeIndex);
            }}
            speed={1000}
            mousewheel={true}
            navigation={true}
            modules={[Autoplay]}
            ref={sliderRef}
            className="testimonials-slider"
          >
            {data.content.map(({ name, description, gender }, index) => (
              <SwiperSlide key={index}>
                <div className="p-12 pr-24 sm:px-4 sm:py-8 bg-[#FCFCFC] border border-gray-200 relative w-full h-full">
                  <div className="w-[75px] h-[75px] rounded-full bg-yellow-200 flex items-center justify-center">
                    <img
                      src={
                        gender === "male"
                          ? personPlaceholderMale
                          : personPlaceholderFemale
                      }
                      alt="person placeholder"
                      className="w-8 h-11"
                    />
                  </div>
                  <h3 className="paragraph-lg-normal text-black mt-5 mb-2">
                    {name}
                  </h3>
                  <img src={stars} alt="testimonials stars" />
                  <p className="paragraph-normal text-gray-600 mt-5 mr-1">
                    {description}
                  </p>
                  <button className="absolute top-12 right-12">
                    <img
                      src={arrowDown}
                      alt="down arrow"
                      className="h-[75px]"
                    />
                  </button>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
